import React, { Component } from "react";
import oibValidation from "../../helperFunctions/oibValidation/oibValidation";
import axiosInstance from "../../api/utils/axiosInstance";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import fetchAllForms from "../../api/formsApi/fetchAllForms";
import { Button } from "antd";
import submitFormsApi from "../../api/formsApi/submitFormsApi";
import {
  formSubmitError,
  formSubmitSuccess,
} from "../../store/actions/forms/formActions";
import UnosZahtjevaReferentView from "../../components/UnosZahtjevaReferentView/UnosZahtjevaReferentView";
import ModalComponent from "../../components/UI/Modal/Modal";
import { Row, Col } from "react-bootstrap";
import { SignatureModal } from "../Signature/SignatureModal";

class UnosZahtjeva extends Component {
  state = {
    formData: [],
    showReqFieldsModal: false,
    steps: {
      selectedForm: "",
      inputMethod: "",
      current: 0,
      oib: "",
      oibValidated: false,
    },
    countryList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    requestsLoaded: false,
    initialFormData: [],
    requestUUID: "",
    selectedFiles: [],
    clearUploadedFile: "",
    formLabel: "",
    error: false,
    invalidOib: false,
    uploadError: false,
    secondaryOib: {
      invalidOib: false,
      value: "",
    },
    showSignatureConfirmation: false,
    zahtjevAtrId: "",
    formId: "",
    isLoading: false,
  };

  componentDidMount = () => {
    this.fetchForms();
  };

  fetchForms = async () => {
    try {
      const res = await fetchAllForms("forms/all?filterByLegalType=true");
      let { data } = res;
      const filteredData = data.filter((x) => x.formId !== 3);

      data = (this.props.authority.ZAHTJEV_ODOBRENJE_REV_DRUSTVO === "false" && this.props.userRole === "ROLE_KORISNIK" ? filteredData : data);


      this.setState({
        formData: data,
      });
    } catch (e) {
      if (e.response.status != 401) {
        toast.info("Nešto je pošlo po krivu!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    }
  };

  setInitialFormData = async () => {
    const { selectedForm, inputMethod } = this.state.steps;
    let res;
    if (inputMethod == 2) {
      res = await fetchFormsApi(`/form/${selectedForm}?opunomocenik=${1}`);
    } else {
      res = await fetchFormsApi(`/form/${selectedForm}?opunomocenik=${0}`);
    }
    const { data } = res;
    this.setState(
      {
        error: false,
        invalidOib: false,
        uploadError: false,
        secondaryOib: {
          invalidOib: false,
          value: "",
        },
        requestsLoaded: false,
        formId: selectedForm,
        initialFormData: data,
        requestUUID: data.requestUUID,
        formLabel: data.formDescription,
      },
      () => {
        this.getCountryList();
      }
    );
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCityAndMuncipalityList();
      }
    );
  };

  getCityAndMuncipalityList = async () => {
    const gradExists = this.state.initialFormData.groupList.map((element) =>
      element.controlList.find((grad) => grad.controlLabel === "Naziv grada")
    );
    // .map(el => el)
    if (gradExists[0]) {
      const { data } = await axiosInstance.get(`/sifarnici/gradOpcina`);
      this.setState(
        {
          cityAndMuncipalityList: data,
        },
        () => {
          this.getDistrictList();
        }
      );
    } else {
      this.getDistrictList();
    }
  };

  getDistrictList = async () => {
    const naseljeExists = this.state.initialFormData.groupList.map((element) =>
      element.controlList.find(
        (naselje) => naselje.controlLabel === "Naziv mjesta"
      )
    );
    // .find(naselje => naselje.controlLabel === "Naziv naselja");

    if (naseljeExists[0]) {
      const { data } = await axiosInstance.get(`/sifarnici/naselja`);
      this.setState({ districtList: data, requestsLoaded: true }, () => {
        this.setUserOib();
      });
    } else {
      this.setState(
        {
          requestsLoaded: true,
        },
        () => {
          this.setUserOib();
        }
      );
    }
  };

  setUserOib = () => {
    const { userRole } = this.props;
    const { oib, subjectOib } = this.props;
    const role = userRole === "ROLE_KORISNIK";
    const { formId } = this.state;

    const oibValue = subjectOib ? subjectOib : oib;

    const setOib = (prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((element) => {
            return {
              ...element,
              controlList: [
                ...element.controlList.map((el) => {
                  return el.controlType === "oib"
                    ? // &&
                    //   el.controlLabel != "OIB društva"
                    {
                      ...el,
                      value: oibValue,
                    }
                    : el;
                }),
              ],
            };
          }),
        ],
      },
    });

    //POPUNI USEROV OIB AKO JE ROLA KORISNIK I AKO KORISNIK NIJE STRANAC
    formId != 2 && this.props.oznakaDrzaveEid &&
      // role &&
      this.setState(setOib, () => {
        this.validateOib(oibValue);
      });
  };

  setUserInputState = (userInputObj, isOib, value, secondaryOib) => {
    this.setState(userInputObj, () => {
      isOib && this.validateOib(value, secondaryOib);
    });
  };

  validateOib = (oib, secondaryOib) => {
    let checkOibValidity = oibValidation(oib);

    //ovo nije dobro nikako
    if (secondaryOib && this.state.formId != "3") {
      this.setState((prevState) => ({
        secondaryOib: {
          ...prevState.secondaryOib,
          invalidOib: !checkOibValidity,
          value: oib,
        },
      }));
      return;
    }

    if (oib.length > 0) {
      this.setState({
        invalidOib: !checkOibValidity,
      });
    } else {
      this.setState({
        invalidOib: false,
      });
    }

    oib && checkOibValidity && this.fetchUserDataByOib(oib);
  };

  dropdownHandler = (e) => {
    e.persist();
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((element) => {
            return {
              ...element,
              controlList: [
                ...element.controlList.map((el) => {
                  return el.uuid == e.target.id
                    ? {
                      ...el,
                      value: e.target.value,
                    }
                    : el;
                }),
              ],
            };
          }),
        ],
      },
    }));
  };

  fetchUserDataByOib = (oib) => {
    const { role } = this.props;
    const userRole = role === "ROLE_KORISNIK";
    let newState = { ...this.state.initialFormData };

    axiosInstance.get(`/sifarnici/oib-data/${oib}`).then((res) => {
      res.data.adresa === ""
        ? this.setState({ ...this.state, invalidOib: false })
        : this.setState({
          ...this.state,
          invalidOib: false,
          initialFormData: {
            ...this.state.initialFormData,
            groupList: [
              ...newState.groupList.map((el) => {
                return {
                  ...el,
                  controlList: [
                    ...el.controlList.map((element) => {
                      return (
                        (element.isCoib &&
                          ((element.controlLabel === "Ime" && {
                            ...element,
                            value: `${res.data.ime} `,
                          }) ||
                            (element.controlLabel === "Prezime" && {
                              ...element,
                              value: res.data.prezime,
                            }) ||
                            (element.controlLabel === "Ime punomoćnika" && {
                              ...element,
                              value: res.data.imeOdgovorneOsobe,
                            }) ||
                            (element.controlLabel ===
                              "Prezime punomoćnika" && {
                              ...element,
                              value: res.data.prezimeOdgovorneOsobe,
                            }) ||
                            (element.controlLabel === "Ulica" && {
                              ...element,
                              value: `${res.data.adresa}`,
                            }) ||
                            (element.controlLabel === "Kućni broj" && {
                              ...element,
                              value: `${res.data.kucniBroj}`,
                            }) ||
                            (element.controlLabel ===
                              "Dodatak kućnom broju" && {
                              ...element,
                              value: res.data.kucniBrojDodatak,
                            }) ||
                            (element.controlLabel === "Naziv grada" && {
                              ...element,
                              value:
                                res.data.sifraGradaOpcine.replace(
                                  /^0+/,
                                  ""
                                ) || "",
                            }) ||
                            (element.controlLabel === "Naziv mjesta" && {
                              ...element,
                              value:
                                res.data.sifraNaselja.replace(/^0+/, "") ||
                                "",
                            }) ||
                            (element.controlLabel === "Poštanski broj" && {
                              ...element,
                              value: res.data.postanskiBroj,
                            }) ||
                            (element.controlLabel === "Naziv županije" && {
                              ...element,
                              value:
                                res.data.sifraZupanije.replace(/^0+/, "") ||
                                "",
                            }) ||
                            (element.controlLabel === "Naziv države" && {
                              ...element,
                              value: res.data.sifraDrzave,
                            }) ||
                            (element.controlLabel ===
                              "Naziv pravne osobe" && {
                              ...element,
                              value: res.data.naziv,
                            }) ||
                            (element.controlLabel ===
                              "Ime ovlaštenog revizora" && {
                              ...element,
                              value: res.data.ime,
                            }) ||
                            (element.controlLabel ===
                              "Prezime ovlaštenog revizora" && {
                              ...element,
                              value: res.data.prezime,
                            }) ||
                            (element.controlLabel ===
                              "Naziv revizorskog društva" && {
                              ...element,
                              value: res.data.naziv,
                            }))) ||
                        (element.controlLabel ===
                          "Registarski broj iz registra ovlaštenih revizora" && {
                          ...element,
                          value: res.data.regBrOvlRevizora,
                        }) ||
                        element
                      );
                    }),
                  ],
                };
              }),
            ],
          },
        });
    });
  };

  setSelectedDate = (date) => {
    this.setState(date);
  };

  checkboxHandler = (e) => {

    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((groupListElement) => {
            return {
              ...groupListElement,
              controlList: [
                ...groupListElement.controlList.map(
                  (controlListElement, indx) => {
                    return controlListElement.uuid == e.target.id
                      ? {
                        ...controlListElement,
                        value: e.target.checked,
                      }
                      : controlListElement;
                  }
                ),
              ],
            };
          }),
        ],
      },
    }));
  };

  setSelectedFiles = (selectedFiles) => {
    if (selectedFiles.file === undefined) {
      return;
    }
    let newState = { ...this.state };
    let test = newState.selectedFiles.find(
      (element) => element.id === selectedFiles.id
    );

    let elementExists = test === undefined ? false : true;
    let newSelectedFiles = [...this.state.selectedFiles];
    if (!elementExists) {
      newSelectedFiles.push(selectedFiles);
    } else {
      let itemIndex = newSelectedFiles.findIndex(
        (element) => element.id === selectedFiles.id
      );
      newSelectedFiles[itemIndex] = selectedFiles;
    }

    this.setState({ ...this.state, selectedFiles: newSelectedFiles });
  };

  removeSelectedFile = (id) => {
    this.setState((prevState) => ({
      selectedFiles: [
        ...prevState.selectedFiles.filter((element) => element.id != id),
      ],
    }));
  };

  submitForm = (error) => {
    if (error) {
      this.setState(
        {
          ...this.state,
          error,
        },
        () => {
          this.OpenReqFieldsModal();
        }
      );
    }
  };

  OpenReqFieldsModal = () => {
    this.setState({ showReqFieldsModal: true });
  };

  hideReqFieldsModal = () => {
    this.setState({ showReqFieldsModal: false });
  };

  OpenRedirectConfModal = () => {
    this.setState({ showRedirectConfModal: true, showReqFieldsModal: false });
  };

  hideRedirectConfModal = () => {
    this.setState({ showRedirectConfModal: false });
  };

  submitFormHandler = (e) => {
    e.preventDefault();

    this.setState({ isLoading: true }, async () => {
      let newState = { ...this.state.initialFormData };
      let { formId } = this.state;

      let error = newState.groupList
        .map((el) => {
          return el.controlList.filter((element) => {
            return (
              element.isVisible &&
              element.required &&
              (element.controlType === "text" ||
                element.controlType === "oib" ||
                element.controlType === "mail" ||
                element.controlType === "date" ||
                element.controlType === "number" ||
                element.controlType === "dropdown")
            );
          });
        })
        .flat()
        .every((element) => element.value.length > 0);

      if (!error) {
        this.submitForm(!error);
        this.setState({ isLoading: false });

        return;
      }

      const mailRegexp =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      const emailControl = newState.groupList[0].controlList
        .flat()
        .find((element) => element.controlType === "mail");

      if (
        emailControl &&
        emailControl.value.length > 0 &&
        !mailRegexp.test(emailControl.value)
      ) {
        toast.info("E-mail koji ste upisali nije ispravan!", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        this.setState({ isLoading: false });

        return;
      }

      if (this.state.invalidOib === true && this.props.oznakaDrzaveEid) {
        this.props.formSubmitError(
          true,
          "OIB je neispravan! Molimo unesite ispravan OIB!"
        );
        this.setState({ isLoading: false });

        return;
      }

      if (
        this.state.secondaryOib.value &&
        this.state.secondaryOib.value.length > 0 &&
        this.state.secondaryOib.invalidOib
      ) {
        this.props.formSubmitError(
          true,
          "OIB je neispravan! Molimo unesite ispravan OIB!"
        );
        this.setState({ isLoading: false });

        return;
      }

      const izjavaSuglasnostChecked = newState.groupList[0].controlList.filter(
        (element) =>
          element.controlType === "checkbox" && element.value == false
      );
      if (izjavaSuglasnostChecked && izjavaSuglasnostChecked.length > 0) {
        if (formId == "5" || formId == "6" || formId == "7" || formId == 8) {
          this.props.formSubmitError(
            true,
            "Molimo prihvatite izjavu i potvrdite suglasnost!"
          );
        } else {
          this.props.formSubmitError(true, "Molimo prihvatite izjavu!");
        }
        this.setState({ isLoading: false });
        return;
      }

      if (error) {
        try {
          const res = await submitFormsApi(
            "/upload/",
            this.state.initialFormData
          );

          const selectedFiles = this.state.selectedFiles.sort(
            (a, b) => a.id - b.id
          );

          selectedFiles.length > 0 &&
            selectedFiles.map(async (element) => {
              const formData = new FormData();
              formData.append("file", element.file);
              formData.append("zahtjevId", res.data.zahtjevId);
              formData.append("zahtjevAtrId", res.data.zahtjevAtrId);
              formData.append("controlIndex", element.id);
              formData.append("vrstaDokumentaId", 1);
              try {
                const response = await axiosInstance.post(
                  "/upload/attachment",
                  formData
                );
              } catch (e) {
                this.props.formSubmitError(
                  false,
                  "Nešto je pošlo po krivu, pokušajte ponovo!"
                );
                this.setState({ isLoading: false });
              }
            });

          this.setState({ zahtjevAtrId: res.data.zahtjevAtrId }, () => {
            this.props.formSubmitSuccess(
              false,
              "Obrazac je uspješno pohranjen!"
            );

            {
              this.props.userRole === "ROLE_KORISNIK"
                ? // ako je user obican korisnik nudi potpisivanje, u suprotnom redirectaj na pregled Zahtjeva
                this.openSignatureConfirmationModal()
                : this.props.history.push("/pregled-zahtjeva");
            }
          });
        } catch (e) {
            this.props.formSubmitError(
              true,
              e.response.data.message ||
              "Nešto je pošlo po krivu, pokušajte ponovo!"
            );
        } finally {
          this.setState({ isLoading: false });
        }
      }
    });
  };

  resetCountryValue = (objData) => {
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel ===
                        "Naziv države" &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: "",
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetGradValue(objData);
      }
    );
  };

  autocompleteCountryHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      return;
    }

    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel === objData.id &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: selectedValue.sifDrzave.toString(),
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetGradValue(objData);
      }
    );
  };

  resetGradValue = (objData) => {
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel ===
                        "Naziv grada" &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: "",
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        // objData.addressGroup == 1 && this.resetNaseljeValue(objData);
        this.resetNaseljeValue(objData);
      }
    );
  };

  resetNaseljeValue = (objData) => {
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel ===
                        "Naziv mjesta" &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: "",
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetPbrValue(objData);
      }
    );
  };

  resetPbrValue = (objData) => {
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((groupListElement) => {
            return {
              ...groupListElement,
              controlList: [
                ...groupListElement.controlList.map(
                  (controlListElement, indx) => {
                    return controlListElement.controlLabel ===
                      "Poštanski broj" &&
                      controlListElement.addressGroup === objData.addressGroup
                      ? {
                        ...controlListElement,
                        value: "",
                      }
                      : controlListElement;
                  }
                ),
              ],
            };
          }),
        ],
      },
    }));
  };

  autocompleteCityHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      this.resetGradValue(objData);
      return;
    }

    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel === objData.id &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: selectedValue.sifGrdOpc.toString(),
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.resetNaseljeValue(objData);
      }
    );
  };

  autocompleteDistrictHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      this.resetNaseljeValue(objData);
      return;
    }
    this.setState(
      (prevState) => ({
        initialFormData: {
          ...prevState.initialFormData,
          groupList: [
            ...prevState.initialFormData.groupList.map((groupListElement) => {
              return {
                ...groupListElement,
                controlList: [
                  ...groupListElement.controlList.map(
                    (controlListElement, indx) => {
                      return controlListElement.controlLabel === objData.id &&
                        controlListElement.addressGroup === objData.addressGroup
                        ? {
                          ...controlListElement,
                          value: selectedValue.sifNaselja.toString(),
                        }
                        : controlListElement;
                    }
                  ),
                ],
              };
            }),
          ],
        },
      }),
      () => {
        this.autocompletePbrHandler(selectedValue, objData);
      }
    );
  };

  autocompletePbrHandler = (selectedValue, objData) => {
    if (selectedValue === null) {
      this.resetPbrValue(objData);
      return;
    }
    this.setState((prevState) => ({
      initialFormData: {
        ...prevState.initialFormData,
        groupList: [
          ...prevState.initialFormData.groupList.map((groupListElement) => {
            return {
              ...groupListElement,
              controlList: [
                ...groupListElement.controlList.map(
                  (controlListElement, indx) => {
                    return controlListElement.controlLabel ===
                      "Poštanski broj" &&
                      controlListElement.addressGroup === objData.addressGroup
                      ? {
                        ...controlListElement,
                        value: selectedValue.brPoste,
                      }
                      : controlListElement;
                  }
                ),
              ],
            };
          }),
        ],
      },
    }));
  };

  dropdownFormHandler = (e) => {
    const value = e.target.value;

    this.setState((prevState) => ({
      steps: {
        ...prevState.steps,
        selectedForm: value,
      },
    }));
  };

  // dropdownNacinUnosaHandler = (e) => {
  //   const value = e.target.value;

  //   this.setState((prevState) => ({
  //     steps: {
  //       ...prevState.steps,
  //       inputMethod: value,
  //     },
  //   }));
  // };

  oibInputStepHandler = (e) => {
    const value = e.target.value;
    this.setState(
      (prevState) => ({
        steps: {
          ...prevState.steps,
          oib: value,
        },
      }),
      () => {
        value.length == 11 && this.validateOibFromSteps(value);
      }
    );
  };

  validateOibFromSteps = (oib) => {
    const checkOibValidity = oibValidation(oib);
    this.setState((prevState) => ({
      steps: {
        ...prevState.steps,
        oibValidated: checkOibValidity,
      },
    }));
  };

  next = () => {
    const { userRole } = this.props;
    const checkIfUserIsAdmin =
      userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

    //ovo je provjera za OIB ako je user korisnik??
    // if (
    //   this.state.steps.current == 0 &&
    //   this.state.steps.inputMethod == 2 &&
    //   this.state.steps.oib.length == 11 &&
    //   !this.state.steps.oibValidated
    // ) {
    //   this.props.formSubmitError(
    //     true,
    //     "OIB je neispravan! Molimo unesite ispravan OIB!"
    //   );
    //   return;
    // }
    this.setState(
      (prevState) => ({
        steps: {
          ...prevState.steps,
          current: prevState.steps.current + 1,
        },
      }),
      () => {
        // userRole === "ROLE_KORISNIK" &&
        //   this.state.steps.current == 2 &&
        //   this.setInitialFormData();
        // checkIfUserIsAdmin &&
        this.state.steps.current == 1 && this.setInitialFormData();
      }
    );
  };

  prev = () => {
    this.setState((prevState) => ({
      selectedFiles: [],
      requestsLoaded: false,
      steps: {
        ...prevState.steps,
        current: prevState.steps.current - 1,
      },
    }));
  };

  redirectToPregledZahtjeva = () => {
    toast.info("Dokument nije potpisan!", {
      position: toast.POSITION.BOTTOM_RIGHT,
    });
    this.props.history.push("/pregled-zahtjeva");
  };

  openSignatureConfirmationModal = () => {
    this.setState({ showSignatureConfirmation: true });
  };

  closeSignatureConfirmationModal = () => {
    this.setState({showSignatureConfirmation: false});
  }

  render() {
    let parentState = { ...this.state };
    const otherProps = {
      clearForm: this.clearFormHandler,
      setUserInputState: this.setUserInputState,
      setSelectedFiles: this.setSelectedFiles,
      parentState: parentState,
      submitForm: this.submitForm,
      setSelectedDate: this.setSelectedDate,
      setUserOib: this.setUserOib,
      dropdownHandler: this.dropdownHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompletePbrHandler: this.autocompletePbrHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      removeSelectedFile: this.removeSelectedFile,
      redirectToPregledZahtjeva: this.redirectToPregledZahtjeva,
      openSignatureConfirmationModal: this.openSignatureConfirmationModal,
      closeSignatureConfirmationModal: this.closeSignatureConfirmationModal,
      checkboxHandler: this.checkboxHandler,
    };

    const formData = [...this.state.formData];

    const { current, selectedForm, oib } = this.state.steps;

    const { userRole } = this.props;
    const checkIfUserIsAdmin = userRole === "ROLE_REFERENT" || userRole === "ROLE_SLUZBENIK";

    return (
      <>
        <UnosZahtjevaReferentView
          isLoading={this.state.isLoading}
          current={current}
          selectedForm={selectedForm}
          dropdownFormHandler={this.dropdownFormHandler}
          otherProps={otherProps}
          formData={formData}
          next={this.next}
          prev={this.prev}
          submitFormHandler={this.submitFormHandler}
          requestsLoaded={this.state.requestsLoaded}
        />
        <ModalComponent
          size="sm"
          show={this.state.showReqFieldsModal}
          onHide={this.hideReqFieldsModal}
          title={
            "Niste popunili sve obavezne podatke za zaprimanje. Želite li nastaviti s unosom?"
          }
        >
          <Row>
            <Col>
              <Button type="primary" block onClick={this.hideReqFieldsModal}>
                Da
              </Button>
            </Col>
            <Col>
              <Button
                block
                type={"danger"}
                onClick={this.OpenRedirectConfModal}
              >
                Ne
              </Button>
            </Col>
          </Row>
        </ModalComponent>
        <ModalComponent
          size="sm"
          show={this.state.showRedirectConfModal}
          onHide={this.hideRedirectConfModal}
          title={
            "Jeste li sigurni da želite odustati od unosa? Podaci neće biti spremljeni! "
          }
        >
          <Row>
            <Col>
              <Button
                block
                type={"primary"}
                onClick={() => this.props.history.push("/")}
              >
                Da
              </Button>
            </Col>
            <Col>
              <Button type="danger" block onClick={this.hideRedirectConfModal}>
                Ne
              </Button>
            </Col>
          </Row>
        </ModalComponent>

        <SignatureModal show={this.state.showSignatureConfirmation} zahtjevAtrId={this.state.zahtjevAtrId} dataType={"zahtjev"} 
          onHide={this.closeSignatureConfirmationModal} onCancel={this.redirectToPregledZahtjeva} onFinished={() => {this.props.history.push("/pregled-zahtjeva")}}/>

      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    subjectOib: state.authentication.subjectOib,
    oib: state.authentication.userData && state.authentication.userData.oib,
    userRole: state.authentication.userData
      ? state.authentication.userData.roles[0].roleName
      : "",
    authority: state.authentication.authority,
    oznakaDrzaveEid: state.authentication.userData.oznakaDrzaveEid
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UnosZahtjeva);
